import { useReleaseFlag } from 'hooks/useReleaseFlags';

export const useLocationV2Enabled = (): boolean => {
  return useReleaseFlag('locations_v2');
};
